module.exports = require("@material-ui/icons/ExpandLess");